import React from 'react';
import {
  Facebook,
  Instagram,
  Linkedin,
  Globe,
  Lock,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  'https://facebook.com',
  'https://twitter.com',
  'https://instagram.com',
  'https://linkedin.com',
];

const TwitterX = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
  >
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-exiser-dark text-white pt-24 pb-12 border-t border-purple-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Top section: Brand + Navigation */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16 text-center md:text-left">

          {/* Brand Section */}
          <div className="flex flex-col items-center text-center">
            <Link to="/" className="group">
              <img
                src="/logo_footer.png"
                alt="Exiser Logo"
                className="w-40 h-40 rounded-full object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </Link>
            <p className="text-lg leading-6 text-gray-400 font-sans mb-6 italic">
              Exercise creatively, Grow exponentially.
            </p>

            <div className="flex space-x-4 justify-center">
              {[Facebook, TwitterX, Instagram, Linkedin].map((Icon, index) => (
                <a
                  key={index}
                  href={SOCIAL_LINKS[index]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 p-2 rounded-full text-white hover:bg-exiser-accent hover:text-exiser-primary transition-all"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-8 text-exiser-accent">
              Company
            </h4>
            <ul className="space-y-4 text-sm font-sans text-gray-300">
              <li><Link to="/about" className="hover:text-exiser-accent transition-colors">About Us</Link></li>
              <li><Link to="/corporate-training" className="hover:text-exiser-accent transition-colors">Corporate</Link></li>
              <li><Link to="/careers" className="hover:text-exiser-accent transition-colors">Careers</Link></li>
              <li>
                <Link to="/adminlogin" className="hover:text-exiser-accent transition-colors flex items-center justify-center md:justify-start gap-2">
                  <Lock className="w-3 h-3" /> Admin Login
                </Link>
              </li>
              <li>
                <a
                  href="https://slime.hostitbro.com:2096/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-exiser-accent transition-colors flex items-center justify-center md:justify-start gap-2"
                >
                  <Globe className="w-3 h-3" /> Partner Webmail
                </a>
              </li>
            </ul>
          </div>

          {/* Courses Links */}
          {/* Quick Links (Header Content) */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-8 text-exiser-accent">
              Quick Links
            </h4>
            <ul className="space-y-4 text-sm font-sans text-gray-300">

              <li>
                <Link
                  to="/categories"
                  className="font-bold text-exiser-accent hover:text-white transition-colors animate-pulse"
                >
                  Programme
                </Link>
              </li>
              <li><Link to="/counselling" className="hover:text-exiser-accent transition-colors">Counselling</Link></li>
              <li>
                <Link
                  to="/book"
                  className="font-bold text-exiser-accent hover:text-white transition-colors animate-pulse"
                >
                  Book Session
                </Link>
              </li>
              <li><Link to="/events" className="hover:text-exiser-accent transition-colors">Events</Link></li>
              <li>
                <Link
                  to="/customer-login"
                  className="font-bold text-exiser-accent hover:text-white transition-colors animate-pulse"
                >
                  Member Login
                </Link>
              </li>

            </ul>
          </div>

          {/* Useful Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-8 text-exiser-accent">
              Information
            </h4>
            <ul className="space-y-4 text-sm font-sans text-gray-300">
              <li><Link to="/contact" className="hover:text-exiser-accent transition-colors">Contact Us</Link></li>
              <li><Link to="/privacy_policy" className="hover:text-exiser-accent transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-exiser-accent transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/refund_policy" className="hover:text-exiser-accent transition-colors">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Notice */}
        <div className="border-t border-white/10 pt-8 text-center text-xs text-gray-500 font-sans uppercase tracking-widest">
          &copy; {new Date().getFullYear()} Exiser Private Limited. | All rights reserved. Transforming minds, inspiring growth.
        </div>
      </div>
    </footer>
  );
};

export default Footer;